import { GetListResult, Record, ReduxState } from 'react-admin';
import { put, select, takeLatest } from 'redux-saga/effects';
import { DataProvider } from '../../../providers/dataProvider';
import { USERS } from '../../../providers/resources';
import { TokenDataDecoded } from '../../../utils/token';
import { User } from '../../../utils/types';
import { resolvedUserConnectedCreator, tokenFoundCreator } from '../../actions/users';
import { CustomReducerState } from '../../reducers';

export const resolveUserConnected = (hydraDataProvider: DataProvider) =>
    function* () {
        const tokenData: TokenDataDecoded | null = yield select(
            (state: ReduxState & CustomReducerState) => state.ticketing.user.tokenData
        );
        if (tokenData) {
            const result: GetListResult = yield hydraDataProvider.getList(USERS, {
                filter: {
                    serialization_groups: ['read_user', 'image', 'read_company'],
                    isSemiAnonymous: false,
                    wcCompanyId: tokenData.company_id,
                    username: tokenData.username,
                },
                sort: {
                    field: 'id',
                    order: 'DESC',
                },
                pagination: { page: 1, perPage: 1 },
            });

            if (result && result.total > 0) {
                const userConnected: Record | User | undefined = result.data.find(
                    (item: Record | User) => item?.originId === tokenData.user_id
                );

                if (userConnected) {
                    yield put(resolvedUserConnectedCreator.fn(userConnected));
                }
            }
        }
    };

const userProvider = (hydraDataProvider: DataProvider) =>
    function* () {
        yield takeLatest(tokenFoundCreator.action, resolveUserConnected(hydraDataProvider));
    };

export default userProvider;
